import type { RoomPriceRankDailyStatusInput } from "@/lib/gql/__generated__/graphql";

import type { ProductRoomPriceRankDailyStatusFormModel } from "../../../../../daily-stasus/type";

type Props = {
	viewModel: ProductRoomPriceRankDailyStatusFormModel["ViewModel"];
};

export const convertToInput = ({ viewModel }: Props) => {
	const { statuses, hotelID } = viewModel;

	const input: RoomPriceRankDailyStatusInput = {
		hotelID,
		statuses: statuses.value.map((status) => {
			return {
				date: status.date.value,
				hotelID: status.hotelID.value,
				priceRankID: status.priceRankID?.value,
			} satisfies RoomPriceRankDailyStatusInput["statuses"][0];
		}),
	} satisfies RoomPriceRankDailyStatusInput;

	return input;
};
